import {useState} from 'react';
import {toast} from 'react-toastify';

import {EntitySettings, useUpdateEntityMutation} from '../../generated/graphql';
import {
  extractErrorMessageFromApolloError,
  propagateErrorsContext,
} from '../../util/errors';

export function useUpdateEntitySettings() {
  const [updateEntity] = useUpdateEntityMutation({
    context: propagateErrorsContext(),
  });
  const [loading, setLoading] = useState(false);

  async function updateEntitySettings(
    entityName: string,
    existingSettings: EntitySettings | null,
    newSettings: Partial<EntitySettings>
  ) {
    let result;
    if (!existingSettings || !entityName) {
      toast.error(`Unable to fetch entity settings`);
      return undefined;
    }
    try {
      result = await updateEntity({
        variables: {
          entityName,
          settings: newSettings,
        },
      });
      setLoading(false);
    } catch (e) {
      const errMsg = extractErrorMessageFromApolloError(e) ?? `${e}`;

      if (newSettings?.disableMagicLinkSharing) {
        toast.error(
          'An error occurred. Your team’s public sharing settings have not been updated. Try again, or contact support.'
        );
      } else {
        toast.error(
          `Error updating entity settings. Please contact support if the problem persists. Error message: ${errMsg}`
        );
      }
      console.error(errMsg);
      return undefined;
    }
    return result;
  }
  return {updateEntitySettings, loading};
}
